import { XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import codesfile from "../assets/AFL_CHAMPION_STATS_2.csv";

function StatisticCodes({ team, onSelectedCode }) {
  const [codes, setCodes] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredCodes, setFilteredCodes] = useState([]);

  const doSelectCode = (code) => {
    console.log("code:", code);
    onSelectedCode(code, team);
  };

  const doInit = () => {
    if (codes.length > 0) {
      return;
    }
    fetch(codesfile)
      .then((r) => r.text())
      .then((text) => {
        const lines = text.split(/\r?\n/);
        const headers = lines[0].split(",");
        const codes = [];
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim();
          const tokens = line.split(",");
          const obj = {};
          for (let j = 0; j < tokens.length; j++) {
            obj[headers[j].trim()] = tokens[j].trim();
          }
          codes.push(obj);
        }
        // console.log("codes:", codes);
        setCodes(codes);
        setFilteredCodes(codes);
        const st = localStorage.getItem("searchCodes");
        if (st) {
          doSearch(st, codes);
        }
      });
  };

  const doSearch = (text, cs) => {
    setSearchText(text);
    const filtered = cs.filter((code) => {
      return (
        code["CHAMPION_STAT_CODE"].toLowerCase().includes(text.toLowerCase()) ||
        code["STATISTIC_CODE"].toLowerCase().includes(text.toLowerCase())
      );
    });
    setFilteredCodes(filtered);
  };

  const handleSearchText = (text) => {
    localStorage.setItem("searchCodes", text);
    doSearch(text, codes);
  };

  useEffect(() => {
    doInit();
  }, []);

  return (
    <>
      <div className="flex-col">
        <div className="flex p-2 justify-between bg-base-200">
          <input
            type="text"
            className="input-generic w-full max-w-xs"
            value={searchText}
            onChange={(e) => {
              handleSearchText(e.target.value);
            }}
            placeholder="Search codes"
          />
          <XMarkIcon
            className="size-6 cursor-pointer"
            onClick={() => onSelectedCode()}
          />
        </div>
        <div className="flex-col h-[40vh] overflow-auto p-2 shadow-lg bg-base-200/80">
          <table className="table-auto w-full">
            <thead className="h-8">
              <tr>
                <th className="text-left">CD code</th>
                <th className="text-left">Code</th>
                <th className="text-left">Description</th>
              </tr>
            </thead>
            <tbody>
              {filteredCodes.map((code, idx) => (
                <tr
                  key={idx}
                  className={
                    idx % 2 !== 0
                      ? "px-1 py-0.5 cursor-pointer"
                      : "px-1 py-0.5 bg-base-300/50 cursor-pointer"
                  }
                  onClick={() => {
                    doSelectCode(code["STATISTIC_CODE"]);
                  }}
                >
                  <td>{code["CHAMPION_STAT_CODE"]}</td>
                  <td className="text-left">{code["STATISTIC_CODE"]}</td>
                  <td>{code["DESC_SHORT"]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <SimpleTreeView
          aria-label="file system navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{ height: 240, flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
        >
          <TreeItem nodeId="1" label="Applications">
            <TreeItem nodeId="2" label="Calendar" />
          </TreeItem>
          <TreeItem nodeId="5" label="Documents">
            <TreeItem nodeId="10" label="OSS" />
            <TreeItem nodeId="6" label="MUI">
              <TreeItem nodeId="8" label="index.js" />
            </TreeItem>
          </TreeItem>
        </SimpleTreeView> */}
      </div>
    </>
  );
}

export default StatisticCodes;
